





















import Vue from 'vue'
const AboutHead = Vue.extend({
  computed: {
    lang () {
      return this.$i18n.locale
    },
    keywords () {
      return [
        {
          title: '效率',
          titleEn: 'EFFICIENCY',
          details: '第一时间响应客户的需求，提供高效的沟通'
        },
        {
          title: '质量',
          titleEn: 'QUALITY',
          details: '为顾客提供市场上高质量的数据、平台以及服务'
        },
        {
          title: '灵活',
          titleEn: 'FLEXIBILITY',
          details: '根据客户的需求，提供灵活性的数据与定制化服务'
        },
        {
          title: '信赖',
          titleEn: 'TRUSTWORTHY',
          details: '提供真实的数据，建立真诚的合作关系'
        }
      ]
    }
  }
})
export default AboutHead
